import React from 'react';
import {CustomButton2, CustomInput, CustomView} from "../../../../../../../../components";

import styles from './style.module.sass'
import errorHandler from "../../../../../../../../utils/errorHandler";

type Props = {
  isLoading: boolean;
  onClose: () => void;
  onNext: (phoneNumber: string) => void;
};

const GetOrExistParent: React.FC<Props> = (props: Props): React.ReactElement => {
  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [phoneNumber, setPhoneNumber] = React.useState<string>("");

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function handleOnSubmitNext(): void {
    const regex = /^09\d{9}$/;
    if (regex.test(phoneNumber)) {
      props.onNext(phoneNumber.replace(/^0/, ''));
    } else {
      errorHandler(9003);
    }
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <CustomView.Container className={styles.getOrExistParentContainer}>
      <CustomView.Row className={styles.title}>جستجوی اولیاء</CustomView.Row>
      <CustomView.Row className={styles.body}>
        <CustomView.Column medium={10}>
          <CustomInput
            type="text"
            onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => setPhoneNumber(event.target.value)}
            label={'شماره موبایل اولیا‌ء'}
            value={phoneNumber}
            placeHolder={"09XX XXX XXXX"}
            textAlign={'center'}
            maxLength={11}
          />
          <CustomView.Row className={styles.footer}>
            <CustomView.Column medium={6}>
              <CustomButton2 title="تایید" onClick={handleOnSubmitNext} isLoading={props.isLoading} />
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <CustomButton2 title="لغو" type={'danger'} onClick={props.onClose} />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  )

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
}

export default GetOrExistParent;
